import { FC, useEffect } from 'react'

import { useAppDispatch, useAppSelector } from 'hooks/store'
import {
  CourseInviteProvider,
  CoursePaymentType,
  CourseTabTitle
} from 'share/domain/course'
import { setTitle } from 'reducers/activecourse/activecourseSlice'
import CourseTabProviderDisplay from 'components/features/dashboard/course/tab/CourseTabProviderDisplay'

interface CourseTabChooseCourseProps {
  coursePaymentType: CoursePaymentType
  courseProviderList: CourseInviteProvider[]
}

const CourseTabChooseCourse: FC<CourseTabChooseCourseProps> = ({
  coursePaymentType,
  courseProviderList
}) => {
  const dispatch = useAppDispatch()
  const activeCourse = useAppSelector((state) => state.activeCourse)

  useEffect(() => {
    let title = ''
    if (activeCourse?.activeTab) {
      title =
        activeCourse.activeTab === 'first'
          ? CourseTabTitle.TAKE_FIRST_COURSE
          : CourseTabTitle.TAKE_SECOND_COURSE
    }

    dispatch(setTitle(title))
  }, [activeCourse.activeTab])

  return (
    <CourseTabProviderDisplay
      coursePaymentType={coursePaymentType}
      courseProviderList={courseProviderList}
    />
  )
}

export default CourseTabChooseCourse
